import { Fragment } from "react";
import { Col, Row } from "reactstrap";
import ButtonCommon from "../../components/ButtonCommon";
import Header from "../../components/Header";
import FAQ from "../Home/FAQ";
import './index.scss'

const LandingPage = (props) => {
	return (
		<Fragment>
			<Header props={props}/>
            <div className="landingPage">
                <h1>
                    Unlock GST PayLater
                </h1>
                <h1>
                    Sign up for Partner program
                </h1>
                <p>
                    File now & clients can Pay Later
                </p>

                <Row>
                    <Col md={4} className="cardsCon">
                        <h2>
                            Grow your bussiness
                        </h2>
                        <p>
                            Earn up to 50,000
                            extra / month
                        </p>
                    </Col>
                    <Col md={4} className="cardsCon">
                        <h2>
                            Fast and easy
                        </h2>
                        <p>
                            Instant loan. No 
                            documentation
                            easy refreeals
                        </p>
                    </Col>
                    <Col md={4} className="cardsCon">
                        <h2>
                            Trusted
                        </h2>
                        <p>
                            No data shared with banks Without OTP based consent
                        </p>
                    </Col>
                </Row>
                <Row>
                    <div className="buttonContainer">
                        <ButtonCommon  title="Become a partner"/>
                        <p>
                            By clicking you aggree to terms and conditions    
                        </p>
                    </div>
                </Row>
                <div className="stepsContainer">
                    <h1>
                        How it works
                    </h1>
                    <Row>
                        <div>
                            Test
                        </div>
                        <div />
                        <div>
                            Test
                        </div>
                        <div />
                        <div>
                            Test
                        </div>
                    </Row>
                </div>
            </div>
            <FAQ />
		</Fragment>
	)
}

export default LandingPage;